import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';
import { NavService } from "../../../_services/NavService.service";


@Component({
  selector: 'app-sales-order-transaction',
  templateUrl: './sales-order-transaction.component.html',
  styleUrls: ['./sales-order-transaction.component.scss']
})
export class SalesOrderTransactionComponent implements OnInit {

  static that: SalesOrderTransactionComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;
  OrderDataArray: any = [];
  isListApiCalled: boolean;
  SOAddress: any = {};


  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private _navService: NavService,
  ) {
    SalesOrderTransactionComponent.that = this;
  }

  ngOnInit() {

    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');


    this._navService.navItem$.subscribe((item) => {
      console.log("current this.CompanyId", this.CompanyId);
      console.log("changed to this.CompanyId", JSON.parse(localStorage.getItem("ChnageCompnayId")).Id);

      if (this.CompanyId != JSON.parse(localStorage.getItem("ChnageCompnayId")).Id) {

        this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
        console.log("shooudl have changed:", this.CompanyId);

        const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
        this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;

        console.log("shooudl have changed:", this.CompanyId);

      }
    });


    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Id']) {
      this.Id = changes['Id'].currentValue;
    }
  }

  async initalizeForm() {
    this.tableDetails = {
      data: [],
      emptyDataMSg: 'Orders not added yet. Please add orders.',
      isColumnNameShow: true,
      columnDetails: [
        { columnName: 'Orders.OrderNo', dataFieldName: 'OrderNo', dataFieldName2: 'OrderDate', divType: 'ftlOrders', color: 'var(--colors-primary-blue-blue-200, #3367FB)' },
        { columnName: "Orders.ReferenceNo", dataFieldName: 'ReferenceNo' },
        { columnName: "Orders.Customer", dataFieldName: 'Customer', dataFieldName2: 'PickupLocationCode', },
        { columnName: 'Ship To Party', dataFieldName: 'warehouseName', dataFieldName2: 'DeliveryLocationCode', },
        { columnName: 'Qty in Case', dataFieldName: 'CaseQty', divType: '' },
        { columnName: 'Total Qty', dataFieldName: 'totalQty', divType: '', alignType: 'right' },
        { columnName: 'Cancel Qty', dataFieldName: 'cancelQty', divType: '', alignType: 'right' },
        { columnName: 'Allocate Qty', dataFieldName: 'allocateQty', divType: '', alignType: 'right' },
        { columnName: 'Pending Qty', dataFieldName: 'pendingQty', divType: '', alignType: 'right' },
        { columnName: 'Weight', dataFieldName: 'totalWeight', divType: '', alignType: 'right' },
        { columnName: "Orders.Amount", dataFieldName: 'Amount', alignType: 'right' },
        { columnName: 'Salesperson', dataFieldName: 'SalesPerson', divType: '' },
        { columnName: 'Orders.Status', dataFieldName: 'OrderStatus', divType: 'status' },
      ]
    };
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {

    Helpers.setLoading(true);

    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;
    this.payload.SearchValue = searchValue || null;
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
    this.payload.OrderNo = null;

    if (this.parentTypearray.includes('customer') || this.shipmentModetypearray.includes('customers') || this.shipmentModetypearray.includes('customer') || this.parentTypearray.includes('customers')) {
      this.payload.CustomerName = Id ? Id : this.Id;
    }
    else {
      this.payload.CustomerName = null;
    }

    this.payload.ShipTo = null;
    this.payload.AllocationStatus = 'All';
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;
    this.payload.UserId = this.userId;
    if (this.referenceType == 'Users') {
      this.payload.salesPersonId = Id ? Id : this.Id;
    }
    else {
      this.payload.salesPersonId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("so_GoodsOutward", "obv_GetOrdersList_NewFlow", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].recordcount;

        response.forEach((item, index) => {
          if (item.AddressToPlot) {
            this.SOAddress[index] = item.AddressToPlot;
          }
        });
        console.log(this.SOAddress, 'this is SO address !');
      }
      this.assignTableFields(pageNo, perPage, response);
      Helpers.setLoading(false);

    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }


  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {
    Helpers.setLoading(true);
    // localStorage.setItem('perPage', perPage);

    // this.payload.Start = pageNo;
    // this.payload.Length = this.totalCount;
    // this.payload.SearchValue = this.searchValue || null;
    // this.payload.CompanyId = this.CompanyId;
    // this.payload.OrderNo =  null;
    // this.payload.SupplierName = null;
    // this.payload.ShipTo = null;
    // this.payload.AllocationStatus = 'All';
    // this.payload.FromDate = this.data.FromDate;
    // this.payload.ToDate = this.data.ToDate;
    // this.payload.Status =  null;
    // this.payload.UserId = this.userId;



    this.payload.Start = pageNo * perPage;
    this.payload.Length = this.totalCount;
    this.payload.SearchValue = searchValue || null;
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
    this.payload.OrderNo = null;

    if (this.parentTypearray.includes('customer') || this.shipmentModetypearray.includes('customers') || this.shipmentModetypearray.includes('customer') || this.parentTypearray.includes('customers')) {
      this.payload.CustomerName = Id ? Id : this.Id;
    }
    else {
      this.payload.CustomerName = null;
    }

    this.payload.ShipTo = null;
    this.payload.AllocationStatus = 'All';
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;
    this.payload.UserId = this.userId;
    if (this.referenceType == 'Users') {
      this.payload.salesPersonId = Id ? Id : this.Id;
    }
    else {
      this.payload.salesPersonId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("so_GoodsOutward", "SalesOrderReportDownload", this.payload).subscribe((response) => {
      this.DownloadFile(response);
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while downloading", error);
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }


  // goToDetailsPage(rowData: any) {
  //   this.router.navigateByUrl(`/so_Orders/edit/${rowData.Id}`);
  // }


}
